/* Barre de progression "livraison offerte" - injection dans la notice d'ajout au panier.
   L'Oiseau de Paradis.

   La notice est construite en JavaScript par le theme (assets/theme.js) et ajoutee au
   body, donc elle ne peut pas etre servie par le snippet Liquid comme les deux autres
   surfaces. Ce script l'observe et y insere le meme balisage.

   Choix delibere : on lit le sous-total DEJA AFFICHE dans la notice plutot que de
   relire /cart.js. Le theme fait deja ce fetch et affiche deja ce total ; une seconde
   lecture creerait une course sur des ajouts rapproches, dans un element detruit au
   bout de 5 secondes. La valeur affichee sert aussi de gabarit de format.

   DOM-only : aucun hook dans le pipeline du theme, aucune requete reseau.
*/
(function () {
  if (window.__ldpFsbNotice) return;
  window.__ldpFsbNotice = true;

  var cfg = window.__ldpFsb;
  if (!cfg || !cfg.enabled) return;
  var threshold = Number(cfg.threshold);
  if (!isFinite(threshold) || threshold <= 0) return;

  // Extrait la valeur numerique d'un prix rendu ("62,30 EUR", "EUR62.30", "62,30 €").
  function parseAmount(text) {
    var m = String(text == null ? '' : text).match(/[0-9][0-9.,\s\u00a0]*[0-9]|[0-9]/);
    if (!m) return null;
    var raw = m[0].replace(/[\s\u00a0]/g, '');
    var dec = raw.match(/([.,])(\d{1,2})$/);
    var normalized;
    if (dec) {
      normalized = raw.slice(0, dec.index).replace(/[.,]/g, '') + '.' + dec[2];
    } else {
      normalized = raw.replace(/[.,]/g, '');
    }
    var value = Number(normalized);
    return isFinite(value) ? value : null;
  }

  // Reformate une valeur en recopiant le format d'un prix deja rendu.
  function formatLike(sample, value) {
    sample = String(sample == null ? '' : sample);
    var m = sample.match(/[0-9][0-9.,\s\u00a0]*[0-9]|[0-9]/);
    if (!m) return String(value);
    var numStr = m[0];
    var prefix = sample.slice(0, m.index);
    var suffix = sample.slice(m.index + numStr.length);
    var dec = numStr.replace(/[\s\u00a0]/g, '').match(/([.,])(\d{1,2})$/);
    var sep = dec ? dec[1] : '.';
    var decimals = dec ? dec[2].length : 0;
    var out = Number(value).toFixed(decimals);
    if (sep !== '.') out = out.replace('.', sep);
    return prefix + out + suffix;
  }

  function buildBar(total, sample) {
    var remaining = threshold - total;
    var percent = Math.round((total / threshold) * 100);
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;
    // L'arrondi peut porter le pourcentage a 100 avant que le seuil soit reellement
    // atteint (ex. 79,80 EUR sur 80 EUR = 99,75%, arrondi a 100). Tant qu'il reste un
    // montant a payer, la barre ne doit jamais paraitre pleine (coherent avec le
    // snippet Liquid des deux autres surfaces).
    if (remaining > 0 && percent >= 100) percent = 99;

    var text;
    if (remaining > 0) {
      text = String(cfg.textRemaining || '').replace('__LDP_AMOUNT__', formatLike(sample, remaining));
    } else {
      text = String(cfg.textReached || '');
    }
    if (!text) return null;

    var wrap = document.createElement('div');
    wrap.className = 'ldp-fsb' + (remaining <= 0 ? ' ldp-fsb--reached' : '');

    var p = document.createElement('p');
    p.className = 'ldp-fsb__text';
    p.innerHTML = text;
    wrap.appendChild(p);

    var track = document.createElement('div');
    track.className = 'ldp-fsb__track';
    track.setAttribute('aria-hidden', 'true');

    var fill = document.createElement('span');
    fill.className = 'ldp-fsb__fill';
    fill.style.width = percent + '%';

    track.appendChild(fill);
    wrap.appendChild(track);
    return wrap;
  }

  function inject(notice) {
    if (notice.getAttribute('data-ldp-fsb')) return;
    var footer = notice.querySelector('.cart-summary__footer');
    if (!footer) return;
    var priceEl = footer.querySelector('.cart-summary__total-price-row .theme-money');
    if (!priceEl) return;
    var total = parseAmount(priceEl.textContent);
    if (total === null) return;

    var bar = buildBar(total, priceEl.textContent);
    if (!bar) return;
    // Le drapeau n'est pose qu'une fois la barre construite : sinon un noeud
    // pourrait etre marque sans rien avoir recu, et plus aucune tentative
    // ulterieure ne pourrait y injecter quoi que ce soit.
    notice.setAttribute('data-ldp-fsb', '1');
    var button = footer.querySelector('.cart-summary__button');
    if (button) {
      footer.insertBefore(bar, button);
    } else {
      footer.appendChild(bar);
    }
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.classList && node.classList.contains('added-notice')) {
      inject(node);
      return;
    }
    if (node.querySelector) {
      var found = node.querySelector('.added-notice');
      if (found) inject(found);
    }
  }

  function start() {
    var existing = document.querySelector('.added-notice');
    if (existing) inject(existing);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          scan(added[j]);
        }
      }
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
